import { useState, useContext, useEffect, forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Messenger from "../../Messenger/Messenger";
import { MessengerContext } from "../../../contexts/MessengerContext";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ComposeMsgDialog = ({ open, close, handleSend }) => {
  const { setTemplate, setRecipientFilter } = useContext(MessengerContext);
  const [name, setName] = useState("");

  const handleClose = () => {
    setTemplate(null);
    setRecipientFilter(null);
    close();
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Compose Message
          </Typography>
          {/* <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button> */}
        </Toolbar>
      </AppBar>
      <DialogContent
        style={{ display: "flex", flexDirection: "column", gap: 20 }}
      >
     
        <Messenger customSender={handleSend} />
       
      </DialogContent>
    </Dialog>
  );
};

export default ComposeMsgDialog;
